// App.js
import React, { useState } from 'react';
import Analytics from './Components/analytics';
import NewApi from './Components/newapi';
import './App.css';

function App() {
  const [activeComponent, setActiveComponent] = useState('analytics');

  return activeComponent === 'newapi' ? (
    <NewApi onShowHome={() => setActiveComponent('analytics')} />
  ) : (
    <Analytics onShowNewApi={() => setActiveComponent('newapi')} />
  );
}

export default App;
